import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { useEffect } from 'react'
import useRelatorioRecallProduto, { LOAD_MESSAGE } from './RelatorioRecallProdutoHook'
import {
  Btn,
  Cnpj,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  Periodo,
  SectionHeader,
} from '../../../../components'
import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'

function RelatorioRecallProduto({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useRelatorioRecallProduto()

  const showLabelWarning = selectedProduto => {
    if (selectedProduto && !selectedProduto.dias_para_vencimento)
      return (
        <div style={{ marginTop: 5, paddingLeft: 10 }}>
          <span style={{ color: '#FF6600' }}>
            Para ver as informações da Data de Fabricação. Preencha o campo "Dias para Vencimento"
            no cadastro de produto.
          </span>
        </div>
      )
    return <></>
  }

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutos(state.selectedEmpresa)
        break

      case LOAD_MESSAGE.RECALL:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getRelatorioRecallProduto(
          selectedTp,
          state.selectedEstoque.id,
          state.selectedProduto.id,
          state.periodo.pInicial,
          state.periodo.pFinal,
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>8.13 - Relatório de Recall de Produto</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid" style={{ marginLeft: 5 }}>
            <div className="p-col-3">
              <CustomDropdown
                filter={true}
                disabled={!selectedTp}
                placeholder="Selecione um Estoque"
                optionLabel={'name'}
                options={state.estoques}
                label={'Estoque'}
                onChange={value => localDispatch.onChange('selectedEstoque', value)}
                value={state.selectedEstoque}
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                filter={true}
                disabled={!selectedTp}
                placeholder="Selecione uma Empresa"
                optionLabel={'name'}
                options={state.empresas}
                label={'Empresa'}
                onChange={value => localDispatch.onChange('selectedEmpresa', value)}
                value={state.selectedEmpresa}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                filter={true}
                filterMatchMode="equals"
                disabled={!selectedTp}
                placeholder="Selecione um Produto"
                optionLabel={'name'}
                options={state.produtos}
                label={'Produto'}
                onChange={value => localDispatch.onChange('selectedProduto', value)}
                value={state.selectedProduto}
              />
              {showLabelWarning(state.selectedProduto)}
            </div>
          </div>
          <div className="p-grid" style={{ marginLeft: 5 }}>
            <div className="p-col-6 p-md-4">
              <Periodo
                btnEnabled={selectedTp}
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onSearchRelatorioPosicoes(
                    pInicial,
                    pFinal,
                    state.selectedEstoque,
                    state.selectedProduto,
                  )
                }
              />
            </div>
            <div className="p-col-2" style={{ marginTop: 25 }}>
              <Btn
                disabled={!selectedTp}
                onClick={() =>
                  localDispatch.onClickGerarExcel(
                    state.recebimento,
                    state.expedicao,
                    state.posicoes,
                    state.selectedProduto,
                  )
                }
              >
                Exportar
              </Btn>
            </div>
          </div>
          <div className="p-col-12" style={{ marginTop: 25 }}>
            <SectionHeader style={{ marginBottom: 15 }}>Recebimentos</SectionHeader>
            <DataTable
              value={state.recebimento}
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.onChange('globalFilterRecebimento', value)}
                ></CustomDataTableHeader>
              }
              globalFilter={state.globalFilterRecebimento}
              paginator={true}
              rows={10}
              emptyMessage="Nenhum recebimento a ser exibido"
            >
              <Column
                field="created_at"
                header="Data de Recebimento"
                style={tableCellCentered(100)}
              />
              <Column field="lote" header="Lote" style={tableCellCentered(200)} />
              <Column
                field="fabricacao"
                header="Fabricação"
                style={tableCellCentered(100)}
                body={data => (data.fabricacao ? data.fabricacao : '------------')}
              />
              <Column field="validade" header="Validade" style={tableCellCentered(100)} />
              <Column field="quantidade" header="Quantidade" style={tableCellCentered(80)} />
              <Column field="identifier" header="Identificador" style={tableCellCentered(100)} />
            </DataTable>
          </div>
          <div className="p-col-12" style={{ marginTop: 25 }}>
            <SectionHeader style={{ marginBottom: 15 }}>Expedições</SectionHeader>
            <DataTable
              value={state.expedicao}
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.onChange('globalFilterExpedicao', value)}
                ></CustomDataTableHeader>
              }
              globalFilter={state.globalFilterExpedicao}
              paginator={true}
              rows={10}
              emptyMessage="Nenhuma expedição a ser exibida"
            >
              <Column
                field="created_at"
                header="Data de Recebimento"
                style={tableCellCentered(100)}
              />
              <Column field="lote" header="Lote" style={tableCellCentered(200)} />
              <Column
                field="fabricacao"
                header="Fabricação"
                style={tableCellCentered(100)}
                body={data => (data.fabricacao ? data.fabricacao : '------------')}
              />
              <Column field="validade" header="Validade" style={tableCellCentered(100)} />
              <Column field="quantidade" header="Quantidade" style={tableCellCentered(80)} />
              <Column
                field="cnpj"
                header="CNPJ"
                style={tableCellCentered(100)}
                body={expedicao => <Cnpj>{expedicao.cnpj}</Cnpj>}
              />
              <Column field="client" header="Cliente" style={tableCellCentered(100)} />
            </DataTable>
          </div>
          <div className="p-col-12" style={{ marginTop: 25 }}>
            <SectionHeader style={{ marginBottom: 15 }}>Estoque</SectionHeader>
            <DataTable
              value={state.posicoes}
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.onChange('globalFilterEstoque', value)}
                ></CustomDataTableHeader>
              }
              globalFilter={state.globalFilterEstoque}
              paginator={true}
              rows={10}
              emptyMessage="Nenhuma posição a ser exibida"
            >
              <Column field="lote" header="Lote" style={tableCellCentered(200)} />
              <Column
                field="fabricacao"
                header="Fabricação"
                style={tableCellCentered(100)}
                body={data => (data.fabricacao ? data.fabricacao : '------------')}
              />
              <Column field="validade" header="Validade" style={tableCellCentered(100)} />
              <Column field="quantidade" header="Quantidade" style={tableCellCentered(80)} />
            </DataTable>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RelatorioRecallProduto))
